import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "@/vantui"
import "reset-css"
import "@/assets/styles/common.css"

// 导入axios
import axios from 'axios'
//自定义指令
import directives from "@/directives"
// 拖拽
import VueDragResize from 'vue-drag-resize'
Vue.filter("RMBformat", val => {
  return "¥" + Number(val).toFixed(2) + "元"
})
//页面适配
(function flexible (window, document) {
  var docEl = document.documentElement
  var dpr = window.devicePixelRatio || 1

  // adjust body font size
  function setBodyFontSize () {
    if (document.body) {
      document.body.style.fontSize = (12 * dpr) + 'px'
    }
    else {
      document.addEventListener('DOMContentLoaded', setBodyFontSize)
    }
  }
  setBodyFontSize();

  // set 1rem = viewWidth / 10
  function setRemUnit () {
    var rem = docEl.clientWidth / 10
    docEl.style.fontSize = rem + 'px'
  }

  setRemUnit()

  // reset rem unit on page resize
  window.addEventListener('resize', setRemUnit)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      setRemUnit()
    }
  })

  // detect 0.5px supports
  if (dpr >= 2) {
    var fakeBody = document.createElement('body')
    var testElement = document.createElement('div')
    testElement.style.border = '.5px solid transparent'
    fakeBody.appendChild(testElement)
    docEl.appendChild(fakeBody)
    if (testElement.offsetHeight === 1) {
      docEl.classList.add('hairlines')
    }
    docEl.removeChild(fakeBody)
  }
}(window, document))





Vue.use(directives)
Vue.config.productionTip = false
axios.defaults.baseURL = 'https://collect.tikgamebox.com';
// axios.defaults.baseURL = 'http://test.tikgamebox.com';
Vue.prototype.$http = axios

Vue.component('vue-drag-resize', VueDragResize)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')